module.exports = __webpack_public_path__ + "d71784ea3743ec133dde6ecbeb0ea86b.svg";